// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3Grz6","label":"SetPasswdForm_label__CUspO"};